export class ContestBody {
  constructor(obj) {
    this.id = obj?.id || null
    this.contestName = obj?.contestName || null
    this.fundingOrganization = obj?.fundingOrganization || null
    this.fundingRecipient = obj?.fundingRecipient || null
    this.fundingSum = obj?.fundingSum || null
    this.nirClient = obj?.nirClient || null
    this.nirLevel = obj?.nirLevel || null
    this.nirNumber = obj?.nirNumber || null
    this.nirType = obj?.nirType || null
  }

  getForAPI() {
    return {
      id: this.id,
      contestName: this.contestName,
      fundingOrganization: this.fundingOrganization,
      fundingRecipient: this.fundingRecipient,
      fundingSum: this.fundingSum,
      nirClient: this.nirClient,
      nirLevel: this.nirLevel,
      nirNumber: this.nirNumber,
      nirType: this.nirType
    }
  }
}
